// eslint-disable-next-line import/prefer-default-export
export function parseAddressData({ locationName, addressLine1, addressLine2, city, stateId, stateName, stateShortName, zipCode, contactEmail, contactPhone, contactPhoneExtension, contactName, dayOfWeekRestricted, saveAddress, autosendType, }) {
    const parsedAddress = {
        name: locationName,
        addressLine1,
        addressLine2,
        city,
        state: {
            id: stateId,
            name: stateName,
            shortName: stateShortName,
        },
        stateName,
        zipCode,
        contactEmail,
        contactPhone,
        contactPhoneExtension,
        contactName,
        dayOfWeekRestricted,
        isSave: saveAddress,
        autosendType,
    };
    return parsedAddress;
}
